import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PassportPublic from "@/pages/PassportPublic";
import { Overview } from "@/components/dashboard/Overview";
import { SearchPanel } from "@/components/dashboard/SearchPanel";
import { ReportsPanel } from "@/components/dashboard/ReportsPanel";
import { PassportPanel } from "@/components/dashboard/PassportPanel";
import { AdminPanel } from "@/components/dashboard/AdminPanel";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/accedi" element={<AuthPage />} />
      <Route path="/passaporto/:token" element={<PassportPublic />} />
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="ricerca" element={<SearchPanel />} />
        <Route path="segnalazioni" element={<ReportsPanel />} />
        <Route path="passaporto" element={<PassportPanel />} />
        <Route path="verifica" element={<AdminPanel />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
